export const STAKING_WALLET = "staking";

export const STAKING_WALLET_HINT =
  "Staking wallet cannot be transferred or withdrawn. It can only be used to purchase staking packages.";

export const isStakingWallet = (value) => String(value || "").trim().toLowerCase() === STAKING_WALLET;

export const formatWalletType = (value) => {
  const s = String(value || "").trim();
  if (!s) return "—";
  if (isStakingWallet(s)) return "Staking";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
